
import cartMixin from '@/mixins/cartMixin'
import saveCartMixin from '@/mixins/saveCartMixin'
import CartProductList from '@/components/CartProductList'

export default {
  name: 'CartHeader',
  components: {
    CartProductList,
  },
  mixins: [cartMixin, saveCartMixin],
  props: {
    loadCartWhenCreated: {
      default: true,
      type: Boolean,
    },
    minimize: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      toggledNav: false,
    }
  },
  computed: {
    quantityProducts() {
      return (
        this.userCart?.order_variants?.reduce(
          (acc, obj) => acc + obj.quantity,
          0
        ) || 0
      )
    },
  },
  watch: {
    $route() {
      this.toggledNav = false
    },
  },
  created() {
    if (!this.userCart || this.userCart.ordered_at != null) {
      if (this.loadCartWhenCreated) this.loadCart()
      this.saveUserAgent()
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch()
    },
  },
}
